import { INTERCOM_COPY } from "@spacecrew/shared";
import { audio } from "../audio/bus.js";
import { send } from "../net/intents.js";
import { intercom, type IntercomMode } from "./store.svelte.js";
import { mesh } from "./mesh.svelte.js";

/** Tiny, cheap capture: the artistic degradation happens on the receive side. */
const VIDEO: MediaTrackConstraints = { width: { ideal: 160 }, height: { ideal: 120 }, frameRate: { ideal: 12, max: 15 }, facingMode: "user" };
const AUDIO: MediaTrackConstraints = { echoCancellation: true, noiseSuppression: true, autoGainControl: true, channelCount: 1 };

export async function openIntercom(mode: Exclude<IntercomMode, "">): Promise<void> {
  audio.unlock();
  intercom.opening = true;
  intercom.error = "";
  try {
    if (!window.isSecureContext || !navigator.mediaDevices?.getUserMedia) {
      if (mode !== "none") { intercom.error = INTERCOM_COPY.insecure; mode = "none"; }
    }
    let stream: MediaStream | null = null;
    if (mode !== "none") {
      try {
        stream = await navigator.mediaDevices.getUserMedia({ video: mode === "av" ? VIDEO : false, audio: AUDIO });
      } catch (e) {
        console.warn("[intercom] getUserMedia failed", e);
        intercom.error = INTERCOM_COPY.denied;
        mode = "none";
      }
    }
    intercom.localStream = stream;
    intercom.mode = mode;
    intercom.muted = false;
    send("intercom.mode", { mode });
    mesh.setLocalStream(stream);
    audio.play("intercom.open");
  } finally {
    intercom.opening = false;
  }
}

/** Diegetic INTERCOM toggle: mutes the mic track (the channel stays open so video keeps flowing). */
export function setMuted(muted: boolean): void {
  intercom.muted = muted;
  for (const t of intercom.localStream?.getAudioTracks() ?? []) t.enabled = !muted;
  audio.play(muted ? "intercom.mute" : "intercom.unmute");
}

export function closeIntercom(): void {
  for (const t of intercom.localStream?.getTracks() ?? []) t.stop();
  mesh.closeAll();
  intercom.reset();
}
